
import * as authenticate from './authenticate/selectors';
import * as checks from './list/selectors';
import * as counters from './counter/selectors';
import * as users from './users/selectors';
import * as suspiciousProfiles from './suspiciousProfiles/selectors';
import * as profileChecks from './profileChecks/selectors';
import * as flash from './flash/selectors';
import * as verification from './verification/selectors';
import * as singleChecks from './singleCheck/selectors';
import * as storage from './storage/selectors';
import * as userHistories from './history/selectors';
import * as leads from './leads/selectors';
import * as profiles from './profile/selectors';
import * as resolves from './resolve/selectors';

export const getAuthenticating = state => authenticate.getAuthenticating(state.authenticate);
export const getAuthenticateUserToken = state => authenticate.getUserToken(state.authenticate);
export const getAuthenticatedUser = state =>
  authenticate.getAuthenticatedUser(state.authenticate);

export const getListCheckLoading = state => checks.getLoading(state.checks);
export const getListCheck = state => checks.getListCheck(state.checks);
export const runCheck = state => checks.runCheck(state.runChecks);

export const getListCounterLoading = state => counters.getLoading(state.counters);
export const getListCounter = state => counters.getListCounter(state.counters);

export const getUserListLoading = state => users.getLoading(state.users);
export const getUserList = state => users.getUserList(state.users);

export const getSuspiciousProfileListLoading = state => suspiciousProfiles.getLoading(state.suspiciousProfiles);
export const getSuspiciousProfileList = state => suspiciousProfiles.getSuspiciousUserList(state.suspiciousProfiles);

export const verifySuspiciousProfile = state => suspiciousProfiles.verifySuspiciousProfile(state.suspiciousProfiles);
export const getSuspiciousVerificationLoading = state => suspiciousProfiles.getVerificationLoading(state.suspiciousProfiles);

export const getChecksByProfileLoading = state => profileChecks.getLoading(state.profileChecks);
export const getChecksByProfile = state => profileChecks.getChecksByProfile(state.profileChecks);

export const getFlashMessage = state => flash.getFlashMessage(state.flash);
export const getFlashShow = state => flash.getFlashMessage(state.flash);
export const getFlashType = state => flash.getFlashType(state.flash);
export const getFlashDuration = state => flash.getFlashDuration(state.flash);

export const getProfileVerifyLoading = state => verification.getLoading(state.profileVerifications);
export const getProfileVerifyList = state => verification.getProfileVerification(state.profileVerifications);

export const getCheckVerifyLoading = state => verification.getLoading(state.checkVerifications);
export const getCheckVerifyList = state => verification.getCheckVerification(state.checkVerifications);

export const getSingleCheckLoading = state => singleChecks.getLoading(state.singleChecks);
export const getSingleCheck = state => singleChecks.getSingleCheck(state.singleChecks);

export const getUserID = state => storage.getUserID(state.storage);
export const getCheckID = state => storage.getCheckID(state.storage);
export const getProfileID = state => storage.getProfileID(state.storage);

export const getUserHistoryLoading = state => userHistories.getLoading(state.userHistories);
export const getUserHistory = state => userHistories.getUserHistory(state.userHistories);

export const getUserLeadLoading = state => leads.getLoading(state.leads);
export const getUserLead = state => leads.getUserLead(state.leads);
export const getLeads = state => leads.getLeads(state.leads);

export const getProfileLoading = state => profiles.getLoading(state.profiles);
export const getProfile = state => profiles.getProfile(state.profiles);

export const getResolveLoading = state => resolves.getLoading(state.resolves);
export const getResolve = state => resolves.getResolve(state.resolves);




// WEBPACK FOOTER //
// ./src/redux/selectors.js